import { ICONS } from "@/common/icons.map";
import {
  InfoTypeHelper,
  POPULATION_TYPE,
  SensitivityLevelHelper,
} from "@/common/models";
import { SharedState } from "@/common/state";
import { isEmpty } from "@/fp";

import { getItemDetails } from "@/gql/types";

export const FileModelHelper = {
  is_email_body(item: any) {
    return item.subType == "Email" && item.category == "Content";
  },
};

const PII_LABELS_CATEGORY_TO_HIDE = [
  "MIP Labels",
  "Virtual",
  "Has MIP Label",
  "External Information",
  "Internal Information",
];

export const fileParser = (res: any) => {
  const { items } = res;

  let cursor = "";
  if (items.length > 0) {
    cursor = items[0].cursor;
  }
  return {
    cursor,
    objects: items.map((item: any) => {
      const archive_items_tooltip_raw = (item?.internalItems || [])
        .filter((d: any) => d && d.name)
        .map((d: any) => d.name);
      const archive_items_tooltip =
        archive_items_tooltip_raw.length > 5
          ? [...archive_items_tooltip_raw.slice(0, 5), "and other files"]
          : archive_items_tooltip_raw;
      const label_from_local =
        SharedState?.allInfoTypes?.value[item?.labels?.infoLabel?.id];
      const { infoLabel, adhocLabels, ctxLabels, piis } = item?.labels;
      const is_email_body =
        item.subType == "Email" && item.category == "Content";
      return {
        ...item,
        hasHistory: item?.labelHistory && item?.labelHistory?.length > 0,
        showConfidence: InfoTypeHelper?.canShowConfidence(item),
        type: POPULATION_TYPE.FILE,
        is_email_body,
        sensitivity: SensitivityLevelHelper.floatToInt(item?.sensitivity),
        file_extension: is_email_body
          ? "Email"
          : ICONS?.EXTENSION?.get(item?.name?.split(".").reverse()[0]),
        labelType: infoLabel?.type,
        label_code: label_from_local?.code,
        parentId: label_from_local?.parentId,
        source: item?.sourceApplication,
        has_adhoc_label: adhocLabels?.length > 0,
        adhoc_label_name: adhocLabels?.map((d: any) => d.name).join(", "),
        has_context_labels: ctxLabels?.length,
        archive: item?.archive,
        archive_items_tooltip,
        piis: piis?.filter((l: any) => {
          return !PII_LABELS_CATEGORY_TO_HIDE.includes(l.labelCategory);
        }),
        hide_menu: isEmpty(item?.clusterUID),
        ctxLabels: ctxLabels?.map((d: any) => ({
          ...d,
          name: d?.name,
          category: d?.type,
          is_folder: d?.labelType === "Folder_context",
        })),
        information: infoLabel,
        details: getItemDetails(item),
      };
    }),
  };
};
